import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { StringUtils } from '../../utils/StringUtils';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class LinkElement extends AbstractBlock {
  constructor() {
    super('link_elem_v2', t.to('リンク', 'link'));
  }

  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getWhiteColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ColorSettings.setObjectColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);
    const urlText = new Blockly.FieldTextInput('');
    const title = new Blockly.FieldTextInput('Link to another world');
    block
      .appendDummyInput()
      .appendField(`${t.to('タイトル', 'title')}:`)
      .appendField(title, 'title');
    block
      .appendDummyInput()
      .appendField(`${t.to('先', 'link_to')}:`)
      .appendField(urlText, 'link_url');

    const imageURL = new Blockly.FieldTextInput('');
    imageURL.setVisible(false);
    block.appendDummyInput().appendField(imageURL, 'image_url');

    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1.7, 0);

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    let url = CodeSetting.getFieldValue(block, 'link_url');
    url = StringUtils.htmlDecode(url);
    const image_path = CodeSetting.getFieldValue(block, 'image_url');
    const title = CodeSetting.getFieldValue(block, 'title');

    // console.log(url, StringUtils.htmlDecode(url));

    let attribute = '';
    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    // attribute += ` class="clickable" href="${url}" image="${image_path}"  borderColor="black" scale="3 4 0 " `;
    attribute += CodeSetting.getAttributeCode('class', 'clickable');
    attribute += CodeSetting.getAttributeCode('href', 'javascript:void(0)');
    attribute += CodeSetting.getAttributeCode('link_into', `href:${url}`);
    attribute += CodeSetting.getAttributeCode('image', image_path);
    attribute += CodeSetting.getAttributeCode('title', title);
    attribute += CodeSetting.getAttributeCode('borderColor', 'black');
    attribute += CodeSetting.getAttributeCode('scale', '3 4 0');
    attribute += CodeSetting.getAttributeCode('on', 'touchstart');
    attribute += CodeSetting.getSubAttributeCode(block);

    //  <a-link  href="vr.html" image="http://localhost/test/f.png"></a-link>
    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
